<template>
    <CardPage :section="11" :page="4" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! You’ve earned another sticker.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
        <p>
            Just remember, there are other potential tools to include in your safer sex toolbox, like dental dams and receptive partner condoms. Click here for
            more information.
            <a href="https://assets2.hrc.org/files/assets/resources/Trans_Safer_Sex_Guide_FINAL.pdf" target="_blank"
                >assets2.hrc.org/files/assets/resources/Trans_Safer_Sex_Guide_FINAL.pdf</a
            >
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section11/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section11/complete', true);
            this.$store.set('section11/sticker@earned', true);
        }
    }
};
</script>
